module.exports = __webpack_public_path__ + "img/banner.1d467a2b.png";